import { GoTrash } from "react-icons/go"
import Button from "./Button"
import { useRemoveStoreMutation } from "../store"
import ProductsList from "./ProductsList"
import { useState } from "react"

const StoresListItems = ({ store }) => {
  const [removeStore, resultRemoveStore] = useRemoveStoreMutation()
  const [showProducts, setShowProduct] = useState(false)

  const handleRemoveStore = () => {
    removeStore(store)
  }

  const handleClick = () => {
    setShowProduct(!showProducts)
  }

  return (
    <div className="border-2 border-gray-300 rounded-lg p-4 mt-4">
      <div className="flex justify-between items-center">
        <h3 className="w-full hover:underline" onClick={handleClick}>
          {store.name}
        </h3>
        <Button onClick={handleRemoveStore}>
          <GoTrash />
        </Button>
      </div>
      {showProducts && (
        <div className="border-2 border-gray-300 rounded-lg p-4 mt-4">
          <ProductsList store={store} />
        </div>
      )}
      {resultRemoveStore.isError && <p>Error while removing the store</p>}
    </div>
  )
}

export default StoresListItems
